import styles from "../EmissaoDeColeta.module.css";
import Container from "../../../../../components/components-ui/Container/Container";
import { BlockScreenLoading } from "../../../../../components/BlockScreenLoading";
import Button from "../../../../../components/components-ui/Button/Button";
import Modal from "../../../../../components/Modal";
import { Table } from "../../../../../components/Table";
import { Grid, Col } from "../../../../../components/Grid";
import { ModalColeta, ModalContrapartida } from "../Modal/";
import api from "../../../../../services/Api";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import {
  customStyles,
  SelectSearch,
} from "../../../../../components/components-ui/SelectSearch/SelectSearch";
import Select from "react-select";
import { Box } from "@mui/material";
import Loading from "../../../../../components/components-ui/Loading/Loading";
import * as Sentry from "@sentry/react";
import { useVerificaPermissao } from "../../../../../utils/verificaPermissao";
import { AuthContext } from "../../../../../Provider/AuthContext";
import CustomConfirmAlert from "../../../../../components/components-ui/CustomConfirmAlert/CustomConfirmAlert";

const API_LOCAIS = "/freguesia/listalocalfreguesia?nome_local=";
// Links
const API_SHOW_DADOS_COLETA = `/coleta/show/`;
const API_DADOS_NOVA_COLETA = `/coleta/new`;
const API_COLETA_VIEW = `/local/view`;
const API_DADOS_STATUS = `/coleta/status/index`;
const API_DADOS_VEICULOS = `/veiculo/index`;
const API_LISTA_EMISSOR = `/usuario/view`;
const API_DADOS_TIPO_COLETA = `/coletatipo/view`;

const API_CREATE_COLETA = `/coleta/create`;
const API_EDIT_COLETA = `/coleta/edit/`;
const API_FORMA_DE_PAGAMENTO = `/formadepagamento`;
const API_CONTRAPARTIDA = `/brinde/index`;
const API_STATUSSUB = `/coleta/statussub`;
const API_COLETA_SUBITEM = `/coleta/subitem/index`;
const API_DADOS_LOCAL_COLETA = "/coleta/getdadoslocal/";
const API_VALIDA_LOCAL = "/coleta/validalocalvinculado/";

const API_EXCLUIR_COLETA = "/coleta/excluir/";

// COLUNAS DAS TABELAS
const columnsColeta = [
  {
    column: "Itens",
  },
  {
    column: "Estimativa Ligação",
  },
];

const columnsContrapartida = [
  {
    column: "Contrapartida",
  },
  {
    column: "Qtde.",
  },
  {
    column: "Total Litros",
  },
  {
    column: "Cortesia",
  },
];

function Action() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();

  const { id } = useParams();
  const navigate = useNavigate();
  const [dadosColeta, setDadosColeta] = useState("");
  const [dadosLocal, setDadosLocal] = useState([]);
  const [dadosStatus, setDadosStatus] = useState([]);
  const [veiculo, setVeiculo] = useState([]);
  const [openModalColeta, setOpenModalColeta] = useState(false);
  const [openModalContrapartida, setOpenModalContrapartida] = useState(false);
  const [dadosModalColeta, setDadosModalColeta] = useState([]);
  const [dadosModalContrapartida, setDadosModalContraPartida] = useState([]);
  const [emissor, setEmissor] = useState([]);
  const [tipoDeColeta, setTipoDeColeta] = useState([]);
  const [dadosNovaColeta, setDadosNovaColeta] = useState([]);
  const [dadosListaColetaSub, setDadosListaColetaSub] = useState([]);
  const [dadosListaContrapartida, setDadosListaContrapartida] = useState([]);
  const [nomeLocal, setNomeLocal] = useState();
  const [blockScreen, setBlockScreen] = useState(false);
  const [formaDePagamento, setFormaDePagamento] = useState([]);
  const [itensContrapartida, setItensContrapartida] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [itens, setItens] = useState([]); // lista com opçoes do select detalhe item
  const [loading, setLoading] = useState(false);
  const [blockSubmit, setBlockSubmit] = useState(false);
  const [inputMarca, setInputMarca] = useState("aa");
  const [loadingInput, setLoadingInput] = useState(false);
  const [locais, setLocais] = useState([]);

  // ALERT PERSONALIZADO
  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg);
    } else {
      toast.error(msg);
    }
  }

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela coletas
    verificaPermissao(idTipoUsuario, 45);
  }, []);

  // CARREGA OS TODAS AS REQUISIÇÃO DOS CAMPOS
  useEffect(() => {
    setLoading(true);
    if (id) {
      // setBlockScreen(true)
      async function getDadosColeta() {
        const response = await api.get(API_SHOW_DADOS_COLETA + id);
        setDadosColeta(response.data.coleta);
        console.log(response.data.coleta);
        setDadosListaColetaSub(response.data.coleta_sub);
        setDadosListaContrapartida(response.data.coleta_contrapartida); // Lista itens contrapartida
        setLoading(false);
        // setBlockScreen(false)
      }
      getDadosColeta();
    }
    // Dados Pra nova coleta
    async function getDadosNovaColeta() {
      const response = await api.get(API_DADOS_NOVA_COLETA);
      setDadosNovaColeta(response.data);
    }
    getDadosNovaColeta();

    //Receber valores do local
    async function getDadosLocal() {
      const response = await api.get(API_COLETA_VIEW);
      setDadosLocal(response.data.data);
    }
    getDadosLocal();
    //Receber valores do local

    async function getDadosStatus() {
      const response = await api.get(API_DADOS_STATUS);
      setDadosStatus(response.data.coleta_status);
    }
    getDadosStatus();
    //Receber nomes dos veiculos
    async function getVeiculo() {
      const response = await api.get(API_DADOS_VEICULOS);
      setVeiculo(response.data);
    }
    getVeiculo();
    // Carrega emissor
    async function getEmissor() {
      const response = await api.get(API_LISTA_EMISSOR);
      setEmissor(response.data);
    }
    getEmissor();
    // Carrega emissor
    async function getTipoColeta() {
      const response = await api.get(API_DADOS_TIPO_COLETA);
      setTipoDeColeta(response.data);
    }
    getTipoColeta();

    // Carregar Forma de Pagamento
    async function getFormaDePagamento() {
      const response = await api.get(API_FORMA_DE_PAGAMENTO);
      setFormaDePagamento(response.data);
    }
    getFormaDePagamento();

    // Carregar opçoes do select Etapa
    async function getEtapas() {
      const response = await api.get(API_STATUSSUB);
      setEtapas(response.data);
    }
    getEtapas();

    // Caregar opçoes do select item
    async function getItens() {
      const response = await api.get(API_COLETA_SUBITEM);
      setItens(response.data);
    }
    getItens();

    // Carregar itens do select contrapartida
    async function getItensContrapartida() {
      const response = await api.get(API_CONTRAPARTIDA);
      setItensContrapartida(response.data);
    }
    getItensContrapartida();

    // localRef.current.autofocus()
  }, [
    API_COLETA_VIEW,
    API_LISTA_EMISSOR,
    API_DADOS_NOVA_COLETA,
    API_DADOS_STATUS,
    API_DADOS_TIPO_COLETA,
    API_DADOS_VEICULOS,
    API_SHOW_DADOS_COLETA,
    id,
  ]);

  const getLocais = async (input) => {
    setLoadingInput(true);
    await api
      .get(API_LOCAIS + input)
      .then((res) => {
        setLocais(res.data.data);
        setLoadingInput(false);
      })
      .catch((error) => {
        setLoadingInput(false);
        console.log(error);
      });
  };

  //Buscar locais ao digitar
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputMarca.length) {
        getLocais(inputMarca);
      } else {
        setLocais([]);
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [inputMarca]);

  const onPressEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  async function novaColeta(values) {
    const dados = {
      IDLocal: values?.local.value,
      DataCriacao: values?.dataCriacao,
      DataPedido: values?.data_pedido,
      IDVeiculo: values?.veiculo,
      IDCriadoPor: values?.criadoPor,
      IDStatus: values?.status,
      Audi_IDUsuario_Criacao: values?.criadoPor,
      Audi_Data_Criacao: values?.dataCriacao,
      Audi_IDUsuario_Alteracao: values?.alteradoPor,
      Audi_Data_Alteracao: values?.dataAlteracao,
      IDStatusSub: values?.etapa,
      IdTipoColeta: values?.tipoColeta,
      HorarioFuncionamento: values?.horarioDeFuncionamento,
      numeroMTR: values?.numeroMTR,
      IdFormaPagamento: values?.formaDePagamento,
      ValorPagamento: values?.valor,
      NumeroPedido: values?.numeroPedido,
      CodigoDaFreguesia: values?.freguesia,
      DiaRetirada: values?.dia,
      ColetaRecado: true,
      DataAgendamento: values?.dataAgendamento,
      NaoTemOleo: values?.naoTemOleo,
      NaoTemOleoObservacao: values?.observacaoNaoTemOleo,
      NaoTemOleoIdUsuario: values?.naoTemOleoCriadoPor,
      NaoTemOleoData: values?.dataNaoTemOleo,
      Observacoes: values?.observacao,
    };

    const data = {
      ...dados,
      coletasub: [{ IDItem: values?.item, Quantidade: values?.itemQtd }],
      contraPartida: dadosListaContrapartida,
    };

    const response = await api
      .post(API_CREATE_COLETA, data)
      .then((response) => {
        if (response.data?.error === 0) {
          toast.success(response.data?.msg, {
            position: "bottom-right",
            autoClose: 2500,
          });
          navigate("/usina/emissao-de-coleta");
        } else if (response.data.error === 1) {
          toast.warn(response.data.msg);
        }
      })
      .catch((e) => {
        toast.error("Algo de errado aconteceu: " + e.message);
        console.log(e);
        Sentry.captureException(e, {
          extra: {
            response: e.response?.data.message,
            status: e.response?.status,
            url: API_EDIT_COLETA + id,
            payload: data,
          },
        });
      });

    return response;
  }

  async function editarColeta(values) {
    const dados = {
      IDColeta: dadosColeta?.IDColeta,
      IDLocal: values?.local.value,
      DataCriacao: values?.dataCriacao,
      DataPedido: values?.data_pedido,
      IDVeiculo: values?.veiculo,
      IDCriadoPor: values?.criadoPor,
      IDStatus: values?.status,
      Audi_IDUsuario_Criacao: values?.criadoPor,
      Audi_Data_Criacao: values?.dataCriacao,
      Audi_IDUsuario_Alteracao: dadosNovaColeta?.user_id,
      Audi_Data_Alteracao: values?.dataAlteracao,
      IDStatusSub: values?.etapa,
      IdTipoColeta: values?.tipoColeta,
      HorarioFuncionamento: values?.horarioDeFuncionamento,
      numeroMTR: values?.numeroMTR,
      IdFormaPagamento: values?.formaDePagamento,
      ValorPagamento: values?.valor,
      NumeroPedido: values?.numeroPedido,
      CodigoDaFreguesia: values?.freguesia,
      DiaRetirada: values?.dia,
      ColetaRecado: values?.recado,
      DataAgendamento: values?.dataAgendamento,
      NaoTemOleo: values?.naoTemOleo,
      NaoTemOleoObservacao: values?.observacaoNaoTemOleo,
      NaoTemOleoIdUsuario: values?.naoTemOleoCriadoPor,
      NaoTemOleoData: values?.dataNaoTemOleo,
      Observacoes: values?.observacao,
    };

    const data = {
      ...dados,
      coletasub: [
        {
          IDColetaSub: dadosListaColetaSub[0]?.IDColetaSub,
          Quantidade: values?.itemQtd,
        },
      ],
    };

    const response = await api
      .put(API_EDIT_COLETA + id, data)
      .then((response) => {
        if (response.data?.error === 0) {
          toast.success(response.data?.msg, {
            position: "bottom-right",
            autoClose: 2500,
          });
        }
        navigate("/usina/emissao-de-coleta");
      })
      .catch((e) => {
        toast.error("Algo de errado aconteceu: " + e.message);
        console.log(e);
        Sentry.captureException(e, {
          extra: {
            response: e.response?.data.message,
            status: e.response?.status,
            url: API_EDIT_COLETA + id,
            payload: data,
          },
        });
      });

    return response;
  }

  function adicionaContrapartida(values, setFieldValue) {
    const infos = itensContrapartida.find(
      (item) => item.id_brinde === values?.contrapartida?.value
    );

    const item = {
      IDBrinde: values?.contrapartida?.value,
      Brinde: values?.contrapartida?.label,
      QuantidadeSolicitada: values?.qtdContrapartida,
      VolumeTotal: values?.totalLitros,
      Bonificacao: values?.brinde,
      ValorUnitario: infos?.ValorVenda,
      ValorTotal: infos?.ValorVenda * Number(values?.qtdContrapartida),
      VolumeUnitario: infos?.VolumeUnitario,
      VolumeTotal: infos?.VolumeTotal * Number(values?.qtdContrapartida),
    };

    if (!values?.contrapartida?.value) {
      toast.error("Selecione uma opção de contrapartida");
      return;
    }

    // Verificar se a quantidade está correta
    if (!values?.qtdContrapartida === "" || values?.qtdContrapartida <= 0) {
      toast.error("Insira uma quantidade válida");
      return;
    }

    // Verificar se o item já foi adicionado
    const verificaItem = dadosListaContrapartida.find(
      (item) => item.IDBrinde === values?.contrapartida?.value
    );

    if (verificaItem) {
      toast.error(
        "Item já existente! Se deseja alterar a quantidade exclua e adicione novamente."
      );
      return;
    }

    // Verifica se esta na tela de edição, caso esteja adiciona a contrapartida direto no banco
    if (id) {
      api
        .post(`/coleta/contrapartida/${id}`, item)
        .then((res) => {
          setDadosListaContrapartida([
            ...dadosListaContrapartida,
            { IDContrapartida: res.data.IDContrapartida, ...item },
          ]);
          toast.success(res.data.msg, { autoClose: 2000 });
        })
        .catch(() => toast.error("Algo de errado aconteceu ao adicionar"));
    } else {
      setDadosListaContrapartida([...dadosListaContrapartida, item]);
    }

    setFieldValue("contrapartida", { value: null, label: "Selecione" });
    setFieldValue("qtdContrapartida", "");
    setFieldValue("totalLitros", "");
    setFieldValue("brinde", false);
  }

  function removeItemContrapartida(value) {
    // Verifica se está na rota de edição, caso esteja deleta o item no banco
    if (id) {
      api
        .delete(`/coleta/contrapartida/${id}/${value?.IDContrapartida}`)
        .then((res) => {
          const itens = dadosListaContrapartida.filter(
            (item) => item.IDContrapartida !== value?.IDContrapartida
          );
          setDadosListaContrapartida([...itens]);
          toast.success(res.data.msg, { autoClose: 2000 });
        })
        .catch((error) => toast.error(error));
    } else {
      const itens = dadosListaContrapartida.filter(
        (item) => item.IDBrinde !== value?.IDBrinde
      );
      setDadosListaContrapartida([...itens]);
    }
  }

  // // FILTRO DE LOCAIS
  // async function getDadosLocal(inputValue) {
  //   const response = await api.get(`/local/viewedit?nome_local=${inputValue}`);
  //   const optionsLocal = response.data.data.map((values) => {
  //     return {
  //       value: values?.id_local,
  //       label: values?.nome_local,
  //     };
  //   });
  //   return optionsLocal;
  // }
  // LISTA NOME DO LOCAL AO CARREGAR EDIÇÃO DA COLETA
  // async function getNomeLocal() {
  //   const response = await api.get(
  //     `/local/viewedit?id_local=${dadosColeta?.id_local}`
  //   );
  //   const optionsLocal = response.data.data.map((values) => {
  //     if (dadosColeta?.id_local === values.id_local) {
  //       setNomeLocal(values.nome_local);
  //     }
  //   });
  //   return optionsLocal;
  // }
  // useEffect(() => {
  //   if (dadosColeta?.id_local) {
  //     getNomeLocal();
  //   }
  // }, [dadosColeta]);

  const customFilter = (option, inputValue) => {
    if (inputValue.length < 3) {
      return false; // Não exibe opções se o texto de entrada for menor que 3 caracteres
    }
    return option.label?.toLowerCase().includes(inputValue?.toLowerCase());
  };

  const handleChangeContrapartida = (selectedOption, setFieldValue) => {
    setFieldValue("qtdContrapartida", "");
    setFieldValue("totalLitros", "");
    setFieldValue("brinde", false);
    setFieldValue("contrapartida", selectedOption); //Seta o valor do select contrapartida como objeto contendo {value: , label: }
  };

  const handleChangeLocal = async (selectedOption, setFieldValue) => {
    setFieldValue("local", selectedOption); // Setar valor do select

    // Validar na tela nova coleta se ja possui alguma coleta para o local selecionado
    if (!id && selectedOption?.value) {
      await api
        .get(API_VALIDA_LOCAL + selectedOption.value)
        .then((res) => {
          if (res.data.error === 1) {
            setBlockSubmit(true);
            toast.error(res.data.msg);
          } else {
            setBlockSubmit(false);
          }
        })
        .catch((error) => console.log(error));
    }

    // Atribuir valores quando o valor do select mudar
    if (selectedOption?.value) {
      await api
        .get(API_DADOS_LOCAL_COLETA + selectedOption.value)
        .then((res) => {
          if (res.data.error === 0) {
            setFieldValue("valor", res.data.data[0].ValorKgContrapartida);
            setFieldValue(
              "formaDePagamento",
              res.data.data[0].IdFormaPagamento
            );
            setFieldValue("dia", res.data.data[0].Retirada01);
            setFieldValue("freguesia", res.data.data[0].Freguesia);
          }
        })
        .catch((error) => console.log(error));
    } else {
      setFieldValue("valor", "");
      setFieldValue("formaDePagamento", null);
      setFieldValue("dia", "");
      setFieldValue("freguesia", "");
    }
  };

  const optionsLocal = dadosLocal.map((values) => ({
    value: values?.id_local,
    label: values?.nome_local,
  }));

  const excluirColeta = async () => {
    CustomConfirmAlert({
      subtitle: `Deseja realmente excluir a coleta nº ${id}?`,
      labelBtnConfirmar: "Confirmar",
      onConfirm: async () => {
        setBlockSubmit(true);
        const promise = api
          .post(API_EXCLUIR_COLETA + id)
          .then((response) => {
            const res = response.data;
            if (res.error !== 0) {
              throw new Error(res.msg || `Erro: ${res.error}`);
            }
            return response;
          })
          .finally(() => setBlockSubmit(false));

        toast.promise(promise, {
          pending: "Carregando...",
          success: {
            render({ data }) {
              const res = data.data;
              if (res.error === 0) {
                return res.msg || `Coleta nº ${id} excluida com sucesso!`;
              }
              throw new Error(res.msg || `Erro: ${res.error}`);
            },
          },
          error: {
            render({ data }) {
              return data?.message || "Erro ao excluir coleta";
            },
          },
        });

        try {
          const response = await promise;
          const res = response.data;
          if (res.error === 0) {
            navigate("/usina/emissao-de-coleta");
          }
        } catch (error) {
          console.error("Erro ao excluir rota: ", error);
        }
      },
    });
  };

  // SCHEMA DE VALIDAÇÃO DO FORMULÁRIO
  const validationSchema = Yup.object().shape({
    numeroColeta: Yup.string(),
    local: Yup.object()
      .shape({
        label: Yup.string().required(),
        value: Yup.number().required(),
      })
      .nullable()
      .required("Selecione o local"),
    status: Yup.string(),
    data_pedido: Yup.date(),
    emissor: Yup.string(),
    veiculo: Yup.string().nullable(),
    tipoColeta: Yup.string().required("Campo Obrigatório"),
    etapa: Yup.string().nullable(),
    numeroMTR: Yup.number().positive("Insira um número válido").nullable(),
    horarioDeFuncionamento: Yup.string(),
    criadoPor: Yup.string(),
    observacao: Yup.string(),
    itemQtd: Yup.number()
      .min(0, "Insira uma quantidade válida")
      .integer("Insira um número inteiro")
      .nullable()
      .required("Campo Obrigatório"),
    qtdContrapartida: Yup.number()
      .min(0, "Insira uma quantidade válida")
      .integer("Insira um número inteiro")
      .nullable(),
    // alteradoPor: Yup.string(),
    // dataAlteracao: Yup.string(),
  });

  return (
    <Container>
      <BlockScreenLoading loading display={blockScreen} />
      <h3> {id ? "Edição de Coleta" : "Cadastro de Coleta"} </h3>
      <section className={styles.content}>
        <Formik
          initialValues={{
            numeroColeta: id ? dadosColeta?.IDColeta : "Nova",
            local: dadosColeta?.IDLocal
              ? {
                  value: dadosColeta?.IDLocal,
                  label: `(${dadosColeta?.IDLocal}) - ${dadosColeta?.marca}`,
                }
              : null,
            numeroPedido: dadosColeta?.NumeroPedido || null,
            status: dadosColeta?.IDStatus ? dadosColeta?.IDStatus : 1,
            data_pedido: dadosColeta?.DataPedido
              ? dadosColeta?.DataPedido
              : dadosNovaColeta?.data_pedido,
            dataAgendamento: dadosColeta?.DataAgendamento || null,
            emissor: id
              ? dadosColeta?.Audi_IDUsuario_Criacao
              : dadosNovaColeta?.user_id,
            tipoColeta: dadosColeta?.idtipocoleta || 1,
            etapa: dadosColeta?.IDStatusSub || 1,
            veiculo: dadosColeta?.IDVeiculo ? dadosColeta?.IDVeiculo : null,
            freguesia: dadosColeta?.CodigoDaFreguesia || null,
            dia: dadosColeta?.DiaRetirada || null,
            numeroMTR: dadosColeta?.numeroMTR || null,
            horarioDeFuncionamento: dadosColeta?.HorarioFuncionamento || "",
            formaDePagamento: dadosColeta?.IdFormaPagamento || null,
            valor: dadosColeta?.ValorPagamento || null,
            recado: !id ? true : Boolean(dadosColeta?.ColetaRecado),
            item: dadosListaColetaSub[0]?.IDItem || 1,
            itemQtd: dadosListaColetaSub[0]?.estimativa_ligacao || null,
            contrapartida: null,
            qtdContrapartida: null,
            totalLitros: null,
            brinde: false,
            naoTemOleo: dadosColeta?.NaoTemOleo || 0,
            naoTemOleoCriadoPor: dadosColeta?.NaoTemOleoIdUsuario || null,
            dataNaoTemOleo: dadosColeta?.NaoTemOleoData || null,
            observacaoNaoTemOleo: dadosColeta?.NaoTemOleoObservacao || "",
            horaDe: "",
            horaAte: "",
            criadoPor: id
              ? dadosColeta?.Audi_IDUsuario_Criacao
              : dadosNovaColeta?.user_id,
            observacao: dadosColeta?.observacao ? dadosColeta?.observacao : "",
            alteradoPor: dadosColeta?.Audi_IDUsuario_Alteracao || null,
            dataCriacao: dadosColeta?.Audi_Data_Criacao || null,
            dataAlteracao: dadosColeta?.Audi_Data_Alteracao || null,
          }}
          enableReinitialize={true}
          onSubmit={(values) =>
            id ? editarColeta(values) : novaColeta(values)
          }
          validationSchema={validationSchema}
        >
          {({ errors, touched, setFieldValue, values, isSubmitting }) =>
            id && loading ? (
              <div style={{ textAlign: "center" }}>
                <Loading />
              </div>
            ) : (
              <Form onKeyDown={onPressEnter}>
                <Grid>
                  <Col size={1}>
                    <label> N° Coleta </label>
                    <Field
                      type="text"
                      name="numeroColeta"
                      disabled
                      className={styles.input_style}
                    />
                    {errors.numeroColeta && touched.numeroColeta ? (
                      <span className={styles.alertError}>
                        {errors.numeroColeta}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={5}>
                    <label> Local </label>
                    {/* <Field name="local">
                      {({ field }) => (
                        <Select
                          {...field}
                          options={optionsLocal}
                          value={optionsLocal.find(
                            (option) => option.value === field.value
                          )}
                          onChange={(selectedOption) =>
                            handleChangeLocal(selectedOption, setFieldValue)
                          }
                          filterOption={customFilter}
                          styles={customStyles}
                          placeholder="Selecione"
                          noOptionsMessage={() => "Digite parte do nome"}
                          isDisabled={
                            dadosColeta?.IDStatus === 2 ||
                            dadosColeta?.IDStatusSub === 2
                          }
                          isClearable
                        />
                      )}
                    </Field> */}
                    <Field name="local">
                      {({ ...field }) => (
                        <Select
                          {...field}
                          value={values.local}
                          options={locais.map((values) => ({
                            label: values?.NomeLocal,
                            value: values?.IdLocal,
                          }))}
                          styles={customStyles}
                          placeholder="Digite para buscar..."
                          noOptionsMessage={() =>
                            loadingInput
                              ? "Carregando..."
                              : inputMarca.length
                              ? "Nenhuma opção encontrada"
                              : "Digite parte do nome"
                          }
                          onChange={(selectedOption) =>
                            handleChangeLocal(selectedOption, setFieldValue)
                          }
                          onInputChange={(e) => setInputMarca(e)}
                          isClearable
                        />
                      )}
                    </Field>
                    {errors.local && touched.local ? (
                      <span className={styles.alertError}>{errors.local}</span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>N° Pedido</label>
                    <Field name="numeroPedido">
                      {({ field }) => (
                        <input
                          type="text"
                          {...field}
                          className={styles.input_style}
                        />
                      )}
                    </Field>
                  </Col>
                  <Col size={3}>
                    <label> Status </label>
                    <Field
                      component={SelectSearch}
                      name="status"
                      options={dadosStatus.map((values) => ({
                        value: values?.id_status,
                        label: values?.status,
                      }))}
                      disabled
                    />
                    {errors.status && touched.status ? (
                      <span className={styles.alertError}>{errors.status}</span>
                    ) : null}
                  </Col>
                </Grid>
                <Grid>
                  <Col size={2}>
                    <label>Data Pedido</label>
                    <Field type="date" name="data_pedido" disabled />
                    {errors.data_pedido && touched.data_pedido ? (
                      <span className={styles.alertError}>
                        {errors.data_pedido}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Data do Agendamento</label>
                    <Field
                      type="date"
                      name="dataAgendamento"
                      disabled={
                        dadosColeta?.IDStatus === 2 ||
                        dadosColeta?.IDStatusSub === 2
                      }
                    />
                    {errors.dataAgendamento && touched.dataAgendamento ? (
                      <span className={styles.alertError}>
                        {errors.dataAgendamento}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label> Emissor </label>
                    <Field
                      component={SelectSearch}
                      name="emissor"
                      options={emissor.map((values) => ({
                        label: values?.nome_usuario,
                        value: values?.id_usuario,
                      }))}
                      disabled
                    />
                    {errors.emissor && touched.emissor ? (
                      <span className={styles.alertError}>
                        {errors.emissor}
                      </span>
                    ) : null}
                  </Col>

                  <Col size={3}>
                    <label> Tipo Coleta </label>
                    <Field
                      component={SelectSearch}
                      name="tipoColeta"
                      options={tipoDeColeta.map((values) => ({
                        label: values?.TipoColeta,
                        value: values?.IdColetaTipo,
                      }))}
                      disabled={
                        dadosColeta?.IDStatus === 2 ||
                        dadosColeta?.IDStatusSub === 2
                      }
                    />
                    {errors.tipoColeta && touched.tipoColeta ? (
                      <span className={styles.alertError}>
                        {errors.tipoColeta}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label> Etapa </label>
                    <Field
                      component={SelectSearch}
                      name="etapa"
                      options={etapas.map((values) => ({
                        value: values?.IdSubStatus,
                        label: values?.Status,
                      }))}
                      disabled
                    />
                    {errors.etapa && touched.etapa ? (
                      <span className={styles.alertError}>{errors.etapa}</span>
                    ) : null}
                  </Col>
                </Grid>
                <Grid>
                  <Col size={3}>
                    <label> Veículo </label>
                    <Field
                      component={SelectSearch}
                      name="veiculo"
                      options={veiculo.map((values) => ({
                        label: values?.placa,
                        value: values?.IDVeiculo,
                      }))}
                      disabled
                    />
                    {errors.veiculo && touched.veiculo ? (
                      <span className={styles.alertError}>
                        {errors.veiculo}
                      </span>
                    ) : null}
                  </Col>

                  <Col size={2}>
                    <label>Freguesia</label>
                    <Field name="freguesia">
                      {({ field }) => (
                        <input
                          type="text"
                          {...field}
                          disabled={
                            dadosColeta?.IDStatus === 2 ||
                            dadosColeta?.IDStatusSub === 2
                          }
                          className={styles.input_style}
                        />
                      )}
                    </Field>
                  </Col>

                  <Col size={2}>
                    <label>Dia</label>
                    <Field name="dia">
                      {({ field }) => (
                        <input
                          type="text"
                          {...field}
                          disabled={
                            dadosColeta?.IDStatus === 2 ||
                            dadosColeta?.IDStatusSub === 2
                          }
                          className={styles.input_style}
                        />
                      )}
                    </Field>
                  </Col>

                  <Col size={2}>
                    <label>N° MTR</label>
                    <Field name="numeroMTR">
                      {({ field }) => (
                        <input
                          type="number"
                          {...field}
                          disabled={
                            dadosColeta?.IDStatus === 2 ||
                            dadosColeta?.IDStatusSub === 2
                          }
                        />
                      )}
                    </Field>
                    {errors.numeroMTR && touched.numeroMTR ? (
                      <span className={styles.alertError}>
                        {errors.numeroMTR}
                      </span>
                    ) : null}
                  </Col>

                  <Col size={3}>
                    <label> Horário de Funcionamento </label>
                    <Field
                      type="text"
                      name="horarioDeFuncionamento"
                      className={styles.input_style}
                      disabled={
                        dadosColeta?.IDStatus === 2 ||
                        dadosColeta?.IDStatusSub === 2
                      }
                    />
                    {errors.horarioDeFuncionamento &&
                    touched.horarioDeFuncionamento ? (
                      <span className={styles.alertError}>
                        {errors.horarioDeFuncionamento}
                      </span>
                    ) : null}
                  </Col>
                  {/* 
              <Col size={2}>
                <label> Hora Coleta De </label>
                <Field type="text" name="horaDe" />
                {errors.horaDe && touched.horaDe ? (
                  <span className={styles.alertError}>{errors.horaDe}</span>
                ) : null}
              </Col>

              <Col size={2}>
                <label> Até </label>
                <Field type="text" name="horaAte" />
                {errors.horaAte && touched.horaAte ? (
                  <span className={styles.alertError}>{errors.horaAte}</span>
                ) : null}
              </Col> */}
                </Grid>

                <Grid>
                  <Col size={3}>
                    <label> Forma De Pagamento </label>
                    <Field
                      name="formaDePagamento"
                      component={SelectSearch}
                      options={formaDePagamento.map((values) => ({
                        value: values?.Id,
                        label: values?.TipoPagamento,
                      }))}
                      disabled={
                        dadosColeta?.IDStatus === 2 ||
                        dadosColeta?.IDStatusSub === 2
                      }
                    />
                    {errors.pagamento && touched.pagamento ? (
                      <span className={styles.alertError}>
                        {errors.pagamento}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Valor Kg</label>
                    <Field
                      name="valor"
                      type="number"
                      step="any"
                      disabled={
                        dadosColeta?.IDStatus === 2 ||
                        dadosColeta?.IDStatusSub === 2
                      }
                    >
                      {/* {({ field }) => (
                        <input type="number" step="any" {...field} />
                      )} */}
                    </Field>
                  </Col>
                  <Col size={2}>
                    <label>Recado?</label>
                    <Field name="recado">
                      {({ field }) => (
                        <input
                          type="checkbox"
                          disabled
                          checked={field.value}
                          {...field}
                        />
                      )}
                    </Field>
                  </Col>
                </Grid>

                <label>Detalhe da Coleta</label>
                <Box border={1} padding={2} marginBottom={1}>
                  <Grid>
                    <Col size={6}>
                      <label> Item </label>
                      <Field
                        component={SelectSearch}
                        name="item"
                        options={itens.map((values) => ({
                          value: values?.IDItem,
                          label: values?.Item,
                        }))}
                        disabled={
                          dadosColeta?.IDStatus === 2 ||
                          dadosColeta?.IDStatusSub === 2
                        }
                      />
                      {errors.item && touched.item ? (
                        <span className={styles.alertError}>{errors.item}</span>
                      ) : null}
                    </Col>
                    <Col size={3}>
                      <label>Quantidade Estimada</label>
                      <Field name="itemQtd">
                        {({ field }) => (
                          <input
                            type="number"
                            step="1"
                            {...field}
                            disabled={
                              dadosColeta?.IDStatus === 2 ||
                              dadosColeta?.IDStatusSub === 2
                            }
                          />
                        )}
                      </Field>
                      {errors.itemQtd && touched.itemQtd ? (
                        <span className={styles.alertError}>
                          {errors.itemQtd}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                </Box>

                <label>Contrapartida</label>
                <Box border={1} padding={2} marginBottom={1}>
                  {dadosColeta?.IDStatus === 2 ||
                  dadosColeta?.IDStatusSub === 2 ? null : (
                    <Grid>
                      <Col size={5}>
                        <label> Contrapartida </label>
                        <Field name="contrapartida">
                          {({ field }) => (
                            <Select
                              {...field}
                              onChange={(selectedOption) =>
                                handleChangeContrapartida(
                                  selectedOption,
                                  setFieldValue
                                )
                              }
                              options={itensContrapartida.map((values) => ({
                                value: values?.id_brinde,
                                label: values?.brinde,
                              }))}
                              placeholder="Selecione"
                              styles={customStyles}
                              isClearable
                              isDisabled={id && dadosColeta?.NaoTemOleo}
                            />
                          )}
                        </Field>
                        {errors.contrapartida && touched.contrapartida ? (
                          <span className={styles.alertError}>
                            {errors.contrapartida}
                          </span>
                        ) : null}
                      </Col>
                      <Col size={2}>
                        <label>Quantidade</label>
                        <Field name="qtdContrapartida">
                          {({ field }) => (
                            <input
                              type="number"
                              step="1"
                              {...field}
                              disabled={id && dadosColeta?.NaoTemOleo}
                            />
                          )}
                        </Field>
                        {errors.qtdContrapartida && touched.qtdContrapartida ? (
                          <span className={styles.alertError}>
                            {errors.qtdContrapartida}
                          </span>
                        ) : null}
                      </Col>
                      {/* <Col size={2}>
                        <label>Total Litros</label>
                        <Field name="totalLitros">
                          {({ field }) => (
                            <input type="number" step="1" {...field} disabled/>
                          )}
                        </Field>
                        {errors.TLts && touched.TLts ? (
                          <span className={styles.alertError}>
                            {errors.TLts}
                          </span>
                        ) : null}
                      </Col> */}
                      <Col size={3}>
                        <label>Brinde?</label>
                        <Field
                          type="checkbox"
                          name="brinde"
                          disabled={id && dadosColeta?.NaoTemOleo}
                        />
                      </Col>
                      <Col size={2}>
                        <Field name="btnContrapartida">
                          {({ field }) => (
                            <Button
                              onClick={() =>
                                adicionaContrapartida(values, setFieldValue)
                              }
                              type="button"
                              title="Adicionar"
                              disabled={
                                blockSubmit || (id && dadosColeta?.NaoTemOleo)
                              }
                            />
                          )}
                        </Field>
                      </Col>
                    </Grid>
                  )}

                  {/* Tabela dados contrapartida */}
                  <Grid>
                    {dadosListaContrapartida.length ? (
                      <Col size={12}>
                        <Table
                          edit={
                            dadosColeta?.IDStatus !== 2 &&
                            dadosColeta?.IDStatusSub !== 2
                          }
                          columns={columnsContrapartida}
                          title="Contrapartida"
                        >
                          {dadosListaContrapartida.map((item, index) => (
                            <tr key={index}>
                              {dadosColeta?.IDStatus !== 2 &&
                                dadosColeta?.IDStatusSub !== 2 && (
                                  <td
                                    onClick={() =>
                                      removeItemContrapartida(item)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </td>
                                )}
                              <td> {item?.Brinde} </td>
                              <td> {item?.QuantidadeSolicitada} </td>
                              <td> {item?.VolumeTotal} </td>
                              <td>{item?.Bonificacao ? "Sim" : "Não"}</td>
                            </tr>
                          ))}
                        </Table>
                      </Col>
                    ) : null}
                    {dadosListaContrapartida.length === 0 &&
                      (dadosColeta?.IDStatus === 2 ||
                        dadosColeta?.IDStatusSub === 2) && (
                        <Col size={12}>
                          <div style={{ textAlign: "center" }}>
                            Nenhuma contrapartida adicionada
                          </div>
                        </Col>
                      )}
                  </Grid>
                </Box>

                {id && dadosColeta?.NaoTemOleo ? (
                  <Grid>
                    <Col size={12}>
                      <Box border={1} padding={2} marginBottom={1}>
                        <Grid>
                          <Field type="checkbox" name="naoTemOleo" disabled />
                          <label style={{ marginLeft: "1rem" }}>
                            Não tem óleo
                          </label>
                        </Grid>
                        <Grid>
                          <Col size={6}>
                            <label> Não tem óleo criado por: </label>
                            <Field
                              component={SelectSearch}
                              name="naoTemOleoCriadoPor"
                              options={emissor.map((values) => ({
                                label: values?.nome_usuario,
                                value: values?.id_usuario,
                              }))}
                              disabled
                            />
                            {errors.naoTemOleoCriadoPor &&
                            touched.naoTemOleoCriadoPor ? (
                              <span className={styles.alertError}>
                                {errors.naoTemOleoCriadoPor}
                              </span>
                            ) : null}
                          </Col>
                          <Col size={3}>
                            <label>Data não tem óleo</label>
                            <Field name="dataNaoTemOleo">
                              {({ field }) => (
                                <input
                                  type="datetime-local"
                                  {...field}
                                  disabled
                                />
                              )}
                            </Field>
                          </Col>
                        </Grid>
                        <Grid>
                          <Col size={12}>
                            <label>Observações Não Tem Óleo</label>
                            <Field
                              component="textarea"
                              name="observacaoNaoTemOleo"
                              className={styles.input_style}
                              disabled
                            />
                          </Col>
                        </Grid>
                      </Box>
                    </Col>
                  </Grid>
                ) : null}
                {/* 
            <Grid>
              <Col size={6}>
                {id ? (
                  <Table
                    edit
                    columns={columnsColeta}
                    title="Detalhe da Coleta"
                  >
                    {dadosListaColetaSub?.map((values, index) => (
                      <tr key={index}>
                        <td>
                          <Link
                            to="#"
                            // onClick={() => deletar(index, dadosModalColeta)}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </Link>
                        </td>
                        <td> {values?.item} </td>
                        <td> {values?.estimativa_ligacao} </td>
                      </tr>
                    ))}
                  </Table>
                ) : (
                  <Table
                    edit
                    columns={columnsColeta}
                    title="Detalhe da Coleta"
                  >
                    {dadosModalColeta.map((values, index) => (
                      <tr key={index}>
                        <td>
                          <Link
                            to="#"
                            onClick={() => deletar(index, dadosModalColeta)}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </Link>
                        </td>
                        <td> {values?.item} </td>
                        <td> {values?.estimativaLigacao} </td>
                      </tr>
                    ))}
                  </Table>
                )} */}

                {/* nao descomentar */}
                {/* // <Table edit columns={columnsColeta} title="Detalhe da Coleta"> 
                  
                //   {dadosModalColeta.map((values, index) => (
                //     <tr key={index}>
                //       <td>
                //         <Link
                //           to="#"
                //           onClick={() => deletar(index, dadosModalColeta)}
                //         >
                //           <i className="fas fa-trash-alt"></i>
                //         </Link>
                //       </td>
                //       <td> {values?.itens} </td>
                //       <td> {values?.estimativaLigacao} </td>
                //     </tr>
                //   ))}
                // </Table>
                */}

                {/* <Button
                  title="Adicionar Item"
                  type="button"
                  onClick={() => setOpenModalColeta(true)}
                />
              </Col>
              <Col size={6}>
                {id ? (
                  <Table
                    edit
                    columns={columnsContrapartida}
                    title="Contrapartida"
                  >
                    {dadosListaContrapartida.map((values, index) => (
                      <tr key={index}>
                        <td>
                          <Link
                            to="#"
                            onClick={() =>
                              deletar(index, dadosModalContrapartida)
                            }
                          >
                            <i className="fas fa-trash-alt"></i>
                          </Link>
                        </td>
                        <td> {values?.brinde} </td>
                        <td> {values?.quantidade_solicitada} </td>
                        <td>
                          {" "}
                          {values?.brinde ? "Com Brinde" : "Sem Brinde"}{" "}
                        </td>
                      </tr>
                    ))}
                  </Table>
                ) : (
                  <Table
                    edit
                    columns={columnsContrapartida}
                    title="Contrapartida"
                  >
                    {dadosModalContrapartida.map((values, index) => (
                      <tr key={index}>
                        <td>
                          <Link
                            to="#"
                            onClick={() =>
                              deletar(index, dadosModalContrapartida)
                            }
                          >
                            <i className="fas fa-trash-alt"></i>
                          </Link>
                        </td>
                        <td> {values?.contrapartida} </td>
                        <td> {values?.quantidade} </td>
                        <td>
                          {values?.brinde ? "Com Brinde" : "Sem Brinde"}
                        </td>
                      </tr>
                    ))}
                  </Table>
                )}

                <Button
                  title="Adicionar Contrapartida"
                  type="button"
                  onClick={() => setOpenModalContrapartida(true)}
                />
              </Col>
            </Grid> */}
                <Grid>
                  <Col size={12}>
                    <label>Observação</label>
                    <Field
                      component="textarea"
                      name="observacao"
                      className={styles.input_style}
                      disabled={
                        dadosColeta?.IDStatus === 2 ||
                        dadosColeta?.IDStatusSub === 2
                      }
                    ></Field>
                    {errors.observacao && touched.observacao ? (
                      <span className={styles.alertError}>
                        {errors.observacao}
                      </span>
                    ) : null}
                  </Col>
                </Grid>

                <Grid>
                  <Col size={3}>
                    <label>Criado Por</label>
                    <Field
                      component={SelectSearch}
                      name="criadoPor"
                      options={emissor.map((values) => ({
                        label: values?.nome_usuario,
                        value: values?.id_usuario,
                      }))}
                      disabled
                    />
                  </Col>
                  <Col size={3}>
                    <label>Data Criação</label>
                    <Field name="dataCriacao">
                      {({ field }) => (
                        <input
                          type="datetime-local"
                          {...field}
                          value={field.value?.slice(0, 16)}
                          disabled
                        />
                      )}
                    </Field>
                  </Col>
                  <Col size={3}>
                    <label>Alterado Por</label>
                    <Field
                      component={SelectSearch}
                      name="alteradoPor"
                      options={emissor.map((values) => ({
                        label: values?.nome_usuario,
                        value: values?.id_usuario,
                      }))}
                      disabled
                    />
                  </Col>
                  <Col size={3}>
                    <label>Data Última Alteração</label>
                    <Field name="dataAlteracao">
                      {({ field }) => (
                        <input
                          type="datetime-local"
                          {...field}
                          value={field.value?.slice(0, 16)}
                          disabled
                        />
                      )}
                    </Field>
                  </Col>
                </Grid>

                <section className={styles.section_button}>
                  {dadosColeta?.IDStatus === 2 ||
                    (dadosColeta?.IDStatusSub === 2 ||
                    (id && dadosColeta?.NaoTemOleo) ? null : (
                      <Button
                        title="Salvar"
                        type="submit"
                        disabled={isSubmitting || blockSubmit}
                      />
                    ))}
                  {id &&
                    dadosColeta?.IDStatus === 1 &&
                    dadosColeta?.IDStatusSub === 1 && (
                      <Button
                        color="tertiary"
                        title="Excluir"
                        disabled={isSubmitting || blockSubmit}
                        onClick={() => {
                          excluirColeta();
                        }}
                        type="button"
                      />
                    )}
                  <Button
                    color="secondary"
                    title="Voltar"
                    disabled={isSubmitting}
                    onClick={() => {
                      navigate("/usina/emissao-de-coleta");
                    }}
                    type="button"
                  />
                </section>
                {isSubmitting && (
                  <div className={styles.loading}>
                    <Loading />
                  </div>
                )}
              </Form>
            )
          }
        </Formik>
      </section>
      <Modal
        width="500px"
        height="200px"
        titleModal="Coletas"
        display={openModalColeta}
        onClick={() => setOpenModalColeta(false)}
      >
        <ModalColeta
          closeModal={setOpenModalColeta}
          data={dadosModalColeta}
          dataColeta={setDadosModalColeta}
        />
      </Modal>
      <Modal
        width="500px"
        height="400px"
        titleModal="Contrapartida"
        display={openModalContrapartida}
        onClick={() => setOpenModalContrapartida(false)}
      >
        <ModalContrapartida
          closeModal={setOpenModalContrapartida}
          data={dadosModalContrapartida}
          dataContrapatida={setDadosModalContraPartida}
        />
      </Modal>
    </Container>
  );
}

export default Action;
